import { jsx } from "react/jsx-runtime";
import "react";
import { noop } from "../../../utils/index.js";
import { IconButton } from "../../IconButton/index.js";
import { useResponsive } from "../../ResponsiveWrapper/index.js";
function DictationButton({ disabled, dictationDisabled, onDictationClickHandler = noop, slots = {
    iconSlot: ''
} }) {
    const { md } = useResponsive();
    const size = md ? 'xs' : '2xs';
    return /*#__PURE__*/ jsx(IconButton, {
        iconName: "mic",
        type: "penny",
        title: "penny-input-dictation",
        emphasis: "regular",
        disabled: disabled || dictationDisabled,
        size: size,
        onClick: onDictationClickHandler,
        slots: {
            iconSlot: slots?.iconSlot
        }
    });
}
export { DictationButton };
